// extracted by mini-css-extract-plugin
export var content = "survey-session-view-module--content--2f+63";
export var profileShortcut = "survey-session-view-module--profileShortcut--jA+si";
export var profileShortcutButton = "survey-session-view-module--profileShortcutButton--lcLfc";
export var profileShortcutText = "survey-session-view-module--profileShortcutText--McoJw";